/**
 * Certification & Equalization defaults per offered course.
 * Add a course label here to auto-fill and activate the field on selection.
 */
export const MALTA_OFFERED_COURSE_CERTIFICATION_EQUALIZATION_BY_LABEL: Readonly<Record<string, string>> = {
  "Master non-med 1st semester": "1 000",
  "Master med 1st semester": "1 000",
};

export const getMaltaOfferedCourseCertificationEqualization = (courseLabel: string): string | undefined =>
  MALTA_OFFERED_COURSE_CERTIFICATION_EQUALIZATION_BY_LABEL[courseLabel];
